export default __webpack_public_path__ + "static/080-a2e8f4ff2f35b6dfb689566d21bff95a.jpg";